<template>
	<!--车辆监控页面_右上角播放操作按钮组开始-->
		<div class="btn-group boot-button right_show_ctrl" role="group" aria-label="..."> 
		  <button style="outline:none;border:none;" type="button" class="btn btn-primary menu_btn right_act_btn" id="tool" @click="toggleMenu"></button>
		   <!--     开始播放         -->
		  <button v-if="isPlaying" style="outline:none;border:none;" type="button" class="btn btn-white" @click="startPlay">
		  	<span><img src="../../../assets/project/images/map/map_icon_7a.png" width="20" height="20" alt=""/></span>
		  </button>
		  <!--     暂停播放         -->
		  <button v-else style="outline:none;border:none;" type="button" class="btn btn-white" @click="stopPlay">
		  	<span><img src="../../../assets/project/images/map/map_icon_7b.png" width="20" height="20" alt=""/></span>
		  </button>
		  <!--     结束播放         -->
		  <button style="outline:none;border:none;" type="button" class="btn btn-white" @click="ceasePlay">
		  	<span><img src="../../../assets/project/images/map/map_icon_79.png" width="20" height="20" alt=""/></span>
		  </button>
		  <button style="outline:none;border:none;" type="button" class="btn btn-white" @click="clickSpeed('2')">
		  	<span :class="{active:times===2 || times===(2/timesPlus)}">2X</span>
		  </button>
		  <button style="outline:none;border:none;" type="button" class="btn btn-white" @click="clickSpeed('4')">
		  	<span :class="{active:times===4 || times===(4/timesPlus)}">4X</span>
		  </button>
		  <button style="outline:none;border:none;" type="button" class="btn btn-white" @click="clickSpeed('8')">
		  	<span :class="{active:times===8 || times===(8/timesPlus)}">8X</span>
		  </button>
		</div>
	<!--车辆监控页面_右上角播放操作按钮组结束--> 
</template>

<script>
	import {mapState} from 'vuex'
	export default{
		name:'VehiclePlay',
		data(){
			return {
				timer:'',
				isPlaying:true,
				isCeased:false,			// 是否结束播放
    			xValGot:false,
    			hasTrack:false,
    			slowSpeed:false,			// 播放到有轨迹的地方，手动降低一下播放的速度。过去之后，还要还原速度。
				times:4,
				timesPlus:30,
				playState:false
			}
		},
		computed:mapState({
			trackInfoList:state => state.vehicle.trackInfoList,
			xVal:state => state.vehicle.xVal,
			startX:state => state.vehicle.startX,
			endX:state => state.vehicle.endX,
			unitX:state => state.vehicle.unitX,
			hasTrackXval:state => state.vehicle.hasTrackXval,
			isDragging:state => state.vehicle.isDragging
		}),
		watch:{		
			xVal:function(val){
				if(val !== undefined){
					this.xValGot = true;
					if(val == this.hasTrackXval){
						this.hasTrack = true;
					}else{
						this.hasTrack = false
					}
				}
			},
			hasTrack: function(val){
				if(val) {
					this.times /= this.timesPlus;
					this.slowSpeed = true;
				}
				if(this.slowSpeed && !val){
					this.times *= this.timesPlus;
					this.slowSpeed = false;
				}
			},
			isDragging: function(val){
				if(val){	// 如果正在拖拽，则暂停播放
					this.playState = this.isPlaying;	// 记录下拖拽之前的播放状态，便于拖拽完毕后恢复状态
					this.stopPlay()
				} else {
					if(!this.playState)
						this.startPlay()
				}
			},
			isPlaying(val){
				if(!this.isDragging){
					this.$store.dispatch('setPlaying',!val);
				}
			}
		},
		beforeDestroy(){
			this.$store.dispatch('setPlaying',false);
			this.ceasePlay();
		},
		methods:{
			autoPlay(){//播放速度控制
		  		clearInterval(this.timer);
		  		this.$store.dispatch('moveFlag')
				const that = this;
				let ballX = this.xVal || 0;
				let length = this.trackInfoList.length
				function move(){
					if(ballX <= that.endX){
						ballX += (that.unitX * that.times);
						that.$store.dispatch('getXval',ballX)
						that.timer = requestAnimationFrame(move);
					}else{
						//停止定时器
						cancelAnimationFrame(that.timer);
						//信息统计部分保存为最后一条数据信息
						const pos = that.trackInfoList[length - 1]
  						that.$store.dispatch('getMomentTrack',pos);
  						//将播放按钮变成停止播放按钮
  						that.isPlaying = true;
  						// 结束播放
  						that.isCeased = true;
					}
				}
				move();
			},
			startPlay(){//开始播放
				// 如果上一次播放结束，重置播放状态
				if(this.xVal >= this.endX){
					this.ceasePlay();
					this.isCeased = false;
				}
				this.isPlaying = false;
				this.autoPlay();
			},
			stopPlay(){//暂停播放
				this.isPlaying = true;
				cancelAnimationFrame(this.timer)
			},
			ceasePlay(){//停止播放-初始化播放状态
				this.isPlaying = true;
				cancelAnimationFrame(this.timer);
				const pos = this.trackInfoList[0]
	  			this.$store.dispatch('getMomentTrack',pos);
	  			const ballX = this.startX;
	  			this.$store.dispatch('getXval',ballX)
			},
			clickSpeed(flag){
				if(flag === '2'){
					this.times = 2;
				} else if(flag === '4'){
					this.times = 4;
				} else if(flag === '8'){
					this.times = 8;
				}
				if(this.hasTrack){
					this.times /= this.timesPlus;
					this.slowSpeed = true;
				}
			},
			toggleMenu(){
				$(".btn-group .btn-white").toggle(300);
			}
		}
		
		
	}
	// requestAnimationFrame简易可兼容的方法
	window.requestAnimationFrame = (function() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame ||
        function( /* function FrameRequestCallback */ callback, /* DOMElement Element */ element) {
            return window.setTimeout(callback, 1000 / 60);
        };
	})();	
</script>
<style>

</style>


// WEBPACK FOOTER //
// VehiclePlay.vue?b898ff0c